import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Input,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd';
import { EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import apiRequest from '../../hooks/ApiRequest';
import Layouts from '../../components/Layouts';
import { toast } from 'react-toastify';
import ClaimFormFieldsForm from './AddEditClaimFormField'; 
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const ClaimFormFields = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const { claimFormId } = useParams();
  const navigate = useHistory();

  useEffect(() => {
    fetchFields();
  }, []);

  const fetchFields = async () => {
    setLoading(true);
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/fields/${claimFormId}`,
        'GET'
      );
      if (response.success || Array.isArray(response)) {
        setFields(response.data || response);
      } else {
        toast.error('Failed to fetch fields');
      }
    } catch (error) {
      toast.error('Error fetching Claim Form Fields');
    } finally {
      setLoading(false);
    }
  };


  const handleSearch = () => {
  };

  const handleEdit = id => {
    setSelectedId(id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async id => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_CLAIM}/ClaimForm/delete/field/${id}`,
        'POST'
      );
      if (response.success || response.message === "Field deleted.") {
        toast.success('Field deleted');
        fetchFields();
      } else {
        toast.error(response.message || 'Delete failed');
      }
    } catch (error) {
      toast.error('Error deleting field');
    }
  };

  const handleFormSuccess = () => {
    setSelectedId(null);
    fetchFields();
  };

  const columns = [
    // { title: 'Id', dataIndex: 'id', key: 'id' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Field Key', dataIndex: 'fieldKey', key: 'fieldKey' },
    { title: 'Type', dataIndex: 'type', key: 'type' },
    // { title: 'ClaimFormId', dataIndex: 'claimFormId', key: 'claimFormId' },
    { title: 'Required', dataIndex: 'isRequired', render: val => (val ? 'Yes' : 'No') },
    { title: 'Email', dataIndex: 'isEmail', render: val => (val ? 'Yes' : 'No') },
    { title: 'Phone Number', dataIndex: 'isPhoneNumber', render: val => (val ? 'Yes' : 'No') },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this Field?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button type="danger" style={{ marginLeft: 8 }}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ];

  const filteredFields = fields.filter(field =>
    field.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div title="Claim Form Fields" classname="dashboard">
      {/* Add/Edit Form on Top */}
      <div className="dash-bg-white" style={{ marginBottom: 24, padding: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3
            style={{
              color: '#0C1362',
              fontWeight: '600',
              fontSize: '20px',
              marginBottom: 0,
            }}
          >
            {selectedId ? 'Update Claim Form Field' : 'Add Claim Form Field'}
          </h3>

          <Button
            type="default"
            onClick={() => navigate.push('/home/claim/forms')}
            style={{
              fontWeight: '500',
              borderRadius: '6px',
              borderColor: '#0C1362',
              color: '#0C1362',
            }}
          >
            Back to Forms
          </Button>
        </div>


        <ClaimFormFieldsForm
          claimFormId={claimFormId}
          fieldId={selectedId}
          onSuccess={handleFormSuccess}
          onCancel={() => setSelectedId(null)}

        />


      </div>

      {/* Field List Table */}
      {loading ? (
        <Spin size="large" style={{ marginTop: 20 }} />
      ) : (
        <Table
          columns={columns}
          dataSource={filteredFields}
          rowKey="id"
          bordered
          size="middle"
          pagination={{ pageSize: 10 }}
          scroll={{ x: 'max-content' }}
        />

      )}
    </div>
  );
};

export default ClaimFormFields;
